export function setText(node: HTMLElement, text: string) {
    let child = node.firstChild;
    if (child && !child.nextSibling && child.nodeType == 3 && 'data' in child) {
        // @ts-ignore
        child.data = text;
    } else {
        node.textContent = text;
    }
}